var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.timeAnswer > 0 && _vm.timeToAnswer > 0 && _vm.timeAnswer < _vm.timeToAnswer)?_c('p',{staticClass:"time-answer__text"},[_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t('youAnsweredIn', {
          msg: '<strong>' + _vm.getTimeCount(_vm.timeAnswer) +'</strong>',
          num: _vm.getTimeCount(_vm.derivedTimeLeft)
        })
      )}}),_c('br'),_c('span',[_vm._v(_vm._s(_vm.$t("waitAndSeeHowYouDid")))])]):_c('p',{staticClass:"time-answer__text"},[_vm._v("\n    "+_vm._s(_vm.$t("runOutOfTime"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }